import {isStaticDataLoading as isStaticDataLoadingSelectorFn} from '@stencil/hotels-details-reducer/src/selectors';
import React from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import DetailsCardLoader from '../../../../../stories/components/hotels/Loadingpage/DetailCardLoader/DetailCardLoader';
import {OuterWrapperDiv} from '../Breadcrumb/Breadcrumb.styles';
// COMPONENTS
import HotelInfo from './HotelInfo/HotelInfo';
import ReviewInfo from './ReviewInfo/ReviewInfo';

const HotelDetailsContainer = styled.section(
  props => `
  display: flex;
  width: 100%;
  // flex-direction: row;
  justify-Content:space-between;
  max-width: 120rem;
  margin: 0 auto;
  // border-radius: 5px;
`,
);

export default function HotelDetails() {
  const isStaticDataLoading = useSelector(isStaticDataLoadingSelectorFn);

  if (isStaticDataLoading) {
    return <DetailsCardLoader />;
  }

  return (
    <OuterWrapperDiv>
      <HotelDetailsContainer>
        <HotelInfo />
        <ReviewInfo />
      </HotelDetailsContainer>
    </OuterWrapperDiv>
  );
}
